import React from "react";
import {passwordApi} from "./passwordApi";
import {locations} from "../../Utilities/Location";
import {PasswordRequestView} from "./PasswordRequestView";
import {LayoutHero} from "../../Components/Layout/";
import {PageTitle} from "../../Components/Landmarks";

interface PasswordRequestContainerProps {
    handleApiCall: (...args: unknown[]) => unknown;
    isLoading: boolean;
    setWarnings: (val: string[]) => void;
    redirect: (path: string) => void;
}

export const PasswordRequestContainer: React.FC<PasswordRequestContainerProps> = ({
                                             handleApiCall,
                                             isLoading,
                                             setWarnings,
                                             redirect,
                                         }) => {

    const handleEmailAsync = async (email: string) => {
        return handleApiCall(() => passwordApi.forgotPassword(email),
            () => redirect(locations.SIGN_IN.path));
    };

    return (
        <LayoutHero>
            <PageTitle h1={locations.FORGOT_PASSWORD.label}/>
            <PasswordRequestView
                handleEmailAsync={handleEmailAsync}
                isLoading={isLoading}
                setWarnings={setWarnings}
            />
        </LayoutHero>
    );
};
